import React from 'react';
import { Divider } from '@material-ui/core';
import SectionCard from './SectionCard';
import ClusterTimerSection from './ClusterTimerSection';
import ClusterIdleSection from './ClusterIdleSection';

/**
 * Everything that can switch this cluster off by itself, in one card.
 *
 * There are two rules and they are not alternatives: a fixed lifetime ("stop
 * after 8 hours of running") and an idle rule ("stop once nobody has used it
 * for 2 hours"). A cluster can carry both, and whichever comes first wins.
 *
 * They share a card because somebody deciding how a cluster ends its life has
 * to see both answers at once. Two separate cards invited exactly the mistake
 * of setting one, scrolling past the other, and being surprised later by the
 * one that was already on.
 */
export default function ClusterShutdownSection({ form, setField, provider, disabled }) {
    return (
        <SectionCard
            icon="power_settings_new"
            title="Automatic Shutdown"
        >
            <ClusterTimerSection form={form} setField={setField} provider={provider} disabled={disabled} />
            <Divider style={{ margin: '24px 0' }} />
            <ClusterIdleSection form={form} setField={setField} provider={provider} disabled={disabled} />
        </SectionCard>
    );
}
